import Andrea from '../../pages/andrea/Andrea'

import PrefixEnum from '../prefixes'

export default Object.freeze([{ path: PrefixEnum.ANDREA, component: Andrea }])
